import AsyncTable from './AsyncTable';
import bank from './bank';
import books from './books';
import cities from './cities';
import countries from './countries';
import discounts from './discounts';
import finance from './finance';
import groups from './groups';
import help from './help';
import HW from './hw';
import journal from './journal';
import modalWindow from './modalWindow';
import notification from './notification';
import offices from './offices';
import olympiad from './olympiad';
import payments from './payments';
import quiz from './quiz';
import roles from './roles';
import suppotrChat from './supportChat';
import user from './user';
import users from './users.list';

export default {
    user,
    books,
    modalWindow,
    cities,
    offices,
    users,
    countries,
    roles,
    finance,
    groups,
    payments,
    AsyncTable,
    HW,
    discounts,
    journal,
    olympiad,
    help,
    bank,
    suppotrChat,
    quiz,
    notification,
};
